import React, { memo } from 'react';
import Flame from '../../../../commons/components/icons/Flame';
import S from './style/ErrorCard';

interface DetailsCardProps {
  title: string;
}

const ErrorCard: React.FC<DetailsCardProps> = function DeliveryMethodCard({ title }) {
  return (
    <S.Card data-cy="error-card">
      <S.Wrapper>
        <S.Title>{title}</S.Title>
        <Flame />
      </S.Wrapper>
    </S.Card>
  );
};

export default memo(ErrorCard);
